import { createRouter, createWebHistory } from 'vue-router';
import WelcomeScreen from '@/components/WelcomeScreen';
import JuryLogin from '../components/JuryLogin.vue';
import JuryProfile from '../components/JuryProfile.vue';
import EvaluationScreen from '../components/EvaluationScreen.vue';
import ResultsScreen from '../components/ResultsScreen.vue';
import JuryResetPassword from '../components/JuryResetPassword.vue';
import store from '../store';

const routes = [
  {
    path: '/',
    name: 'WelcomeScreen',
    component: WelcomeScreen,
  },
  {
    path: '/jury-login',
    name: 'JuryLogin',
    component: JuryLogin,
    meta: { guest: true },
  },
  {
    path: '/evaluation',
    name: 'EvaluationScreen',
    component: EvaluationScreen,
    meta: { requiresAuth: true },
  },
  {
    path: '/results',
    name: 'ResultsScreen',
    component: ResultsScreen,
    meta: { requiresAuth: true },
  },
  {
    path: '/jury-profile',
    name: 'JuryProfile',
    component: JuryProfile,
    meta: { requiresAuth: true },
  },
  {
    path: '/jury/reset-password',
    name: 'JuryResetPassword',
    component: JuryResetPassword,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to protect routes
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const hasJuryData = !!store.state.jury;

  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      // Not authenticated, redirect to login
      next('/jury-login');
      return;
    }

    // If authenticated but no jury data, try to restore session
    if (!hasJuryData) {
      try {
        const restored = await store.dispatch('restoreSession');
        if (!restored) {
          // Session restoration failed, redirect to login
          next('/jury-login');
          return;
        }
      } catch (error) {
        console.error('Session restoration error:', error);
        next('/jury-login');
        return;
      }
    }
  }

  // Redirect to evaluation if already logged in and trying to access login page
  if (to.meta.guest && isAuthenticated && hasJuryData) {
    next('/evaluation');
    return;
  }

  next();
});

export default router;